export default __webpack_public_path__ + "static/media/TripadvisorLogo.8c9ca2d4.png";